export const localStorageKeys = {
  user: '@IN6-user',
  token: '@IN6-token',
  keepConnected: '@IN6-keepConnected',
  vacanciesCustomSteps: '@IN6-vacanciesCustomSteps',
};
